import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ResourceCard = ({ resource, onDownload, onPreview, onBookmark }) => {
  const getFileIcon = (type) => {
    switch (type?.toLowerCase()) {
      case 'pdf':
        return 'FileText';
      case 'doc': case'docx':
        return 'FileText';
      case 'xls': case'xlsx':
        return 'Sheet';
      case 'ppt': case'pptx':
        return 'Presentation';
      case 'zip':
        return 'Archive';
      case 'mp4':
        return 'Video';
      case 'mp3':
        return 'Music';
      default:
        return 'File';
    }
  };

  const formatFileSize = (bytes) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i))?.toFixed(2)) + ' ' + sizes?.[i];
  };

  const formatDate = (dateString) => {
    return new Date(dateString)?.toLocaleDateString('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    });
  };

  return (
    <div className="bg-card rounded-lg border border-border p-6 hover:shadow-card-shadow-lg transition-all duration-300 group">
      <div className="flex items-start justify-between mb-4">
        <div className="flex-1">
          <h3 className="font-semibold text-foreground group-hover:text-primary transition-colors duration-200">
            {resource?.title}
          </h3>
          <p className="text-sm text-muted-foreground mt-1">{resource?.description}</p>
        </div>
        <button
          onClick={() => onBookmark(resource?.id)}
          className={`p-2 rounded-lg transition-colors duration-200 ${
            resource?.isBookmarked
              ? 'text-accent bg-accent/10 hover:bg-accent/20' :'text-muted-foreground hover:text-foreground hover:bg-muted'
          }`}
        >
          <Icon name={resource?.isBookmarked ? 'Bookmark' : 'BookmarkPlus'} size={18} />
        </button>
      </div>
      <div className="flex items-center justify-between text-sm text-muted-foreground mb-4">
        <div className="flex items-center space-x-4">
          <span className="flex items-center space-x-1">
            <Icon name="Calendar" size={14} />
            <span>Updated {formatDate(resource?.updatedAt)}</span>
          </span>
        </div>
      </div>
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-2">
          <span className={`px-2 py-1 rounded-full text-xs font-medium ${
            resource?.category === 'Forms' ? 'bg-blue-100 text-blue-800' :
            resource?.category === 'Policies' ? 'bg-green-100 text-green-800' :
            resource?.category === 'Tenders' ? 'bg-orange-100 text-orange-800' :
            resource?.category === 'Academic'? 'bg-purple-100 text-purple-800' : 'bg-gray-100 text-gray-800'
          }`}>
            {resource?.category}
          </span>
          {resource?.isNew && (
            <span className="px-2 py-1 rounded-full text-xs font-medium bg-accent/20 text-accent">
              New
            </span>
          )}
        </div>
        
        <div className="flex items-center space-x-2">
          <Button
            variant="ghost"
            size="sm"
            iconName="Eye"
            onClick={() => onPreview(resource)}
          >
            Preview
          </Button>
          {resource?.category?.toLowerCase() !== 'policies' && (
            <Button
              variant="default"
              size="sm"
              iconName="Download"
              onClick={() => onDownload(resource)}
            >
              Download
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ResourceCard;